<!-- <p-dialog [(visible)]="visible" modal="true" [closable]="false" [resizable]="false">
  <iframe width="700" height="345" src="https://www.sigess.app/avisoprivacidad.html">
  </iframe>
  <p-footer>
    ¿Acepta los términos?
    <button (click)="aceptar(true)" pButton label="SI" title="Al marcar SI se entenderá que acepta la política de tratamiento de datos personales y podrá continuar con el uso del sistema"></button>
    <button (click)="aceptar(false)" pButton class="ui-button-secondary" label="NO" [title]="msgNoAcepta"></button>
  </p-footer>
</p-dialog> -->

<div class="dialog" #btn>
  <div class="content">
    <p style="margin-top:0px;text-align: justify;font-weight: bold;">
      A continuación encontrará nuestra política de tratamiento de datos personales. Por favor leala cuidadosamente y después especifique
      si acepta los términos
    </p>
    <iframe style="border:solid thin #ccc;" width="700" height="345" src="https://sigess.app/avisoprivacidad.html">
    </iframe>
    <div style="margin-top:10px;">
      ¿Acepta los términos?
      <button (click)="opSi.toggle($event)" pButton label="SI"></button>
      <button (click)="opNo.toggle($event)" pButton class="ui-button-secondary" label="NO"></button>
    </div>
  </div>
</div>

<p-overlayPanel #opNo [appendTo]="btn" baseZIndex="5100">

  <p style="width: 300px;">Al marcar NO se entenderá que no está de acuerdo con la política de tratamiento de datos personal,
    en cuyo caso la sesión será finalizada. ¿Esta seguro de NO aceptar?</p>

  <button style="margin-top: 10px;" (click)="marcarAceptacion(false)" pButton class="ui-button-warning" icon="fa fa-exclamation"
    label="No aceptar"></button>

</p-overlayPanel>

<p-overlayPanel #opSi [appendTo]="btn" baseZIndex="5100">

  <p style="width: 300px;">Al marcar SI se entenderá que acepta la política de tratamiento de datos personales y podrá continuar
    con el uso del sistema. ¿Confirma la aceptación de la política?</p>

  <button style="margin-top: 10px;" (click)="marcarAceptacion(true)" pButton icon="fa fa-check" label="Aceptar"></button>

</p-overlayPanel>